import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { QuerySortOrder } from "@/common/types/querySortOrder.type";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseProductCategoriesProps<T> = {
  filters?: {
    search?: string;
    page?: number;
  };
  sort?: {
    displayName?: QuerySortOrder;
  };
  mapper?: (data: any) => T,
};

export const useProductCategories = <T,>({
  filters: { search = '', page } = {},
  sort: {
    displayName: sortDisplayName = QuerySortOrder.Ascending,
  } = {},
  mapper = Mapper.default<T>(),
}: UseProductCategoriesProps<T>) => {
  const privateAxios = usePrivateAxios();

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['productCategories', search, page, sortDisplayName],
    queryFn: () => {
      return privateAxios.get('/product_categories', {
        params: {
          search,
          page,
          'sort[display_name]': sortDisplayName,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
